import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 16\" class=\"design-iconfont\" id=\"icon-phone\">\n  <path d=\"M12,0 C13.1045695,-2.02906125e-16 14,0.8954305 14,2 L14,14 C14,15.1045695 13.1045695,16 12,16 L4,16 C2.8954305,16 2,15.1045695 2,14 L2,2 C2,0.8954305 2.8954305,1.3527075e-16 4,0 L12,0 Z M9,14 L7,14 L7,15 L9,15 L9,14 Z M12,2 L4,2 L4,13 L12,13 L12,2 Z\" fill=\"#000\" transform=\"translate(-2)\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol